import {IComponentOptions} from 'angular';
import {DvDialog} from '../../directive/dv-dialog/dv-dialog';
import ITranslateService = angular.translate.ITranslateService;
import IScope = angular.IScope;
import {ShowTooltipController} from '../../dialog/ShowTooltipController';
let template = require('./dv-tooltip.html');
require('./dv-tooltip.scss');
let showTooltipTemplate = require('../../dialog/showTooltipTemplate.html');

export class DvTooltipComponentConfig implements IComponentOptions {
    transclude = false;
    template = template;
    controller = DvTooltipController;
    controllerAs = 'vm';
    bindings: any = {
        text: '<'
    };
}

export class DvTooltipController {

    static $inject: any[] = ['$translate', 'DvDialog'];
    /* @ngInject */
    constructor(private $translate: ITranslateService, private DvDialog: DvDialog) {
    }

    showTooltip(text: any): void {
        this.DvDialog.showDialog(showTooltipTemplate, ShowTooltipController, {
            text: text
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-tooltip/dv-tooltip.ts